// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.road-damages {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.road-damages-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.road-damages-head {
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-bottom: 18px;
  padding-bottom: 18px;
  border-bottom: 2px solid #111;
  margin-bottom: 22px;
}

.road-head-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.road-summary-block h3 {
  margin: 0 0 10px;
  color: #2d4a3a;
  font-size: 1rem;
}

.road-head-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.road-download-btn,
.road-map-btn,
.road-remedy-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 600;
  cursor: pointer;
}

.road-download-btn {
  border: 1px solid #4a7c59;
  background: #f4faf6;
  color: #2d4a3a;
}

.road-download-btn:hover {
  background: #e5f3ea;
}

.road-map-btn {
  border: 1px solid #2f6f9f;
  background: #f3f8fc;
  color: #1f4f73;
}

.road-map-btn:hover {
  background: #e4f0f8;
}

.road-summary {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.road-summary-card {
  background: #f4faf6;
  border: 1px solid #d7eadc;
  border-radius: 12px;
  padding: 10px 16px;
  min-width: 120px;
  display: flex;
  flex-direction: column;
}

.road-summary-card strong {
  font-size: 1.4rem;
  color: #2d4a3a;
}

.road-summary-card span {
  color: #5d7466;
  font-size: 0.85rem;
}

.attach-damage-btn {
  background: #4a7c59;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 12px 18px;
  font-weight: 600;
  cursor: pointer;
}

.attach-damage-btn:hover {
  background: #3d684b;
}

.road-empty {
  color: #5d7466;
  margin: 8px 0 0;
}

.road-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.road-card {
  display: grid;
  grid-template-columns: 160px 1fr 230px;
  gap: 14px;
  background: #fff;
  border: 1px solid #e3eee6;
  border-radius: 14px;
  overflow: hidden;
}

.road-card-photo,
.road-card > img {
  width: 160px;
  height: 100%;
  min-height: 160px;
  object-fit: cover;
  background: #eef5f0;
}

.road-card-body {
  padding: 12px 14px 12px 0;
  color: #2d4a3a;
}

.road-card-body p {
  margin: 2px 0;
  font-size: 0.92rem;
}

.road-card-top {
  display: flex;
  align-items: center;
  gap: 10px;
}

.road-card-top h4 {
  margin: 0;
}

.road-card-title {
  font-weight: 700;
}

.road-card-date {
  color: #6b7f72;
  font-size: 0.82rem !important;
}

.sev {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.85rem;
  color: #1d3326;
}

.sev-N1 { background: #b7e4c7; }
.sev-N2 { background: #ffe08a; }
.sev-N3 { background: #f4a261; }
.sev-N4 { background: #e76f6f; color: #fff; }

.road-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(20, 32, 24, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 72px 16px 40px;
  z-index: 1200;
  overflow: auto;
}

.road-modal {
  background: #fff;
  width: min(640px, 100%);
  border-radius: 16px;
  padding: 18px 18px 22px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.road-modal-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.road-modal-head h3 {
  margin: 0;
  color: #2d4a3a;
}

.road-close {
  border: none;
  background: transparent;
  font-size: 1.6rem;
  cursor: pointer;
  line-height: 1;
}

.road-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #2d4a3a;
  font-weight: 600;
  font-size: 0.92rem;
}

.road-field input,
.road-field select,
.road-field textarea {
  font-weight: 400;
  font-size: 16px;
  border: 1px solid #c9ddd0;
  border-radius: 8px;
  padding: 8px 10px;
  color: #2d4a3a;
  background: #fff;
  font-family: inherit;
}

.road-field textarea {
  resize: vertical;
}

.road-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #5d7466;
  font-size: 0.85rem;
}

.road-preview img {
  width: 120px;
  height: 90px;
  object-fit: cover;
  border-radius: 8px;
}

.road-camera {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: stretch;
}

.road-camera video,
.road-camera > img {
  width: 100%;
  max-height: min(58vh, 480px);
  object-fit: contain;
  border-radius: 12px;
  background: #12241b;
}

.road-camera .attach-damage-btn,
.road-camera .road-cancel {
  align-self: center;
}

.road-camera-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
}

.road-detection {
  position: relative;
  display: block;
}

.road-detection img {
  width: 100%;
  height: auto;
  max-height: 420px;
  object-fit: contain;
  background: #12241b;
}

.road-box {
  position: absolute;
  border: 3px solid #e23b3b;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.4);
}

.road-box span {
  position: absolute;
  left: -3px;
  top: -1.6rem;
  background: #e23b3b;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  white-space: nowrap;
}

.road-result {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #2d4a3a;
  font-weight: 600;
}

.road-note {
  margin: 0;
  color: #5d7466;
  font-size: 0.88rem;
}

.road-error {
  margin: 0;
  color: #9b2c2c;
  font-weight: 600;
}

.road-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.road-cancel {
  background: #eef3f0;
  border: none;
  border-radius: 10px;
  padding: 12px 16px;
  cursor: pointer;
  color: #2d4a3a;
}

.road-card-actions {
  display: flex;
  gap: 8px;
  margin-top: 9px;
}

.road-small-btn,
.road-delete-btn {
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 0.82rem;
  cursor: pointer;
}

.road-small-btn {
  border: 1px solid #4a7c59;
  color: #365d42;
  background: #f4faf6;
}

.road-small-btn:hover {
  background: #e8f4eb;
}

.road-delete-btn {
  border: 1px solid #d38b8b;
  color: #8d2f2f;
  background: #fff6f6;
}

.road-delete-btn:hover {
  background: #fdeaea;
}

.road-card-status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 14px;
  border-left: 1px solid #e3eee6;
}

.road-card-status.is-ok {
  background: #f3faf5;
}

.road-card-status.is-open {
  background: #fff7f6;
}

.road-status-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
}

.road-card-status.is-ok .road-status-label {
  color: #217a45;
}

.road-card-status.is-open .road-status-label {
  color: #b42318;
}

.road-card-status.is-pending {
  background: #fff8e8;
}

.road-card-status.is-pending .road-status-label {
  color: #8a5a00;
}

.road-review-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c48a12;
  background: #fff4d6;
  color: #7a4e00;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 600;
  cursor: pointer;
}

.road-review-btn:hover {
  background: #ffe8ad;
}

.road-delete-pending {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #fff8e8;
  color: #8a5a00;
  font-weight: 700;
}

.road-delete-pending span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.road-pin {
  background: transparent;
  border: none;
}

.road-pin span {
  display: block;
  width: 16px;
  height: 16px;
  margin-left: 3px;
  border-radius: 50% 50% 50% 0;
  transform: rotate(-45deg);
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
}

.road-remedy-btn {
  border: 1px solid #217a45;
  background: #217a45;
  color: #fff;
}

.road-remedy-btn:hover {
  background: #1b6539;
}

.road-remedy-thumb {
  width: 96px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
}

.road-export-modal {
  width: min(420px, 100%);
}

.road-export-options,
.road-remedy-choices {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.road-file-label {
  width: fit-content;
}

.road-remedy-preview {
  width: 100%;
  max-height: 320px;
  object-fit: contain;
  border-radius: 12px;
  background: #eef5f0;
}

.road-map-backdrop {
  z-index: 1200;
}

.road-map-modal {
  width: min(960px, 100%);
  background: #fff;
  border-radius: 16px;
  padding: 18px;
}

.road-map {
  width: 100%;
  height: min(70vh, 620px);
  min-height: 380px;
  margin-top: 14px;
  border-radius: 12px;
  z-index: 1;
}

.road-map-popup {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 190px;
}

.road-map-popup img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  border-radius: 6px;
  margin-bottom: 4px;
}

.road-work-order {
  margin-top: 8px !important;
  padding: 8px 10px;
  background: #f4faf6;
  border-left: 3px solid #4a7c59;
  border-radius: 6px;
  line-height: 1.35;
}

.road-video-icon {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid #4a7c59;
  border-radius: 999px;
  background: #f4faf6;
  color: #2d4a3a;
  cursor: pointer;
}

.road-video-icon:hover {
  background: #e5f3ea;
}

.road-video-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.road-video-field video,
.road-video-preview,
.road-video-player {
  width: 100%;
  min-height: 220px;
  max-height: 420px;
  background: #111;
  border-radius: 12px;
}

.attach-damage-btn:disabled,
.road-cancel:disabled,
.road-close:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 860px) {
  .road-card {
    grid-template-columns: 140px 1fr;
  }
  .road-card-status {
    grid-column: 1 / -1;
    border-left: none;
    border-top: 1px solid #e3eee6;
  }
}

@media (max-width: 640px) {
  .road-card {
    grid-template-columns: 1fr;
  }
  .road-card-photo,
  .road-card > img {
    width: 100%;
    height: 180px;
  }
  .road-card-body {
    padding: 0 12px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/project/RoadDamagesPanel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,UAAU,mBAAmB,EAAE;AAC/B,UAAU,mBAAmB,EAAE;AAC/B,UAAU,mBAAmB,EAAE;AAC/B,UAAU,mBAAmB,EAAE,WAAW,EAAE;;AAE5C;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;;IAEE,WAAW;IACX,aAAa;EACf;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".road-damages {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.road-damages-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.road-damages-head {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  margin-bottom: 18px;\n  padding-bottom: 18px;\n  border-bottom: 2px solid #111;\n  margin-bottom: 22px;\n}\n\n.road-head-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.road-summary-block h3 {\n  margin: 0 0 10px;\n  color: #2d4a3a;\n  font-size: 1rem;\n}\n\n.road-head-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.road-download-btn,\n.road-map-btn,\n.road-remedy-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.road-download-btn {\n  border: 1px solid #4a7c59;\n  background: #f4faf6;\n  color: #2d4a3a;\n}\n\n.road-download-btn:hover {\n  background: #e5f3ea;\n}\n\n.road-map-btn {\n  border: 1px solid #2f6f9f;\n  background: #f3f8fc;\n  color: #1f4f73;\n}\n\n.road-map-btn:hover {\n  background: #e4f0f8;\n}\n\n.road-summary {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.road-summary-card {\n  background: #f4faf6;\n  border: 1px solid #d7eadc;\n  border-radius: 12px;\n  padding: 10px 16px;\n  min-width: 120px;\n  display: flex;\n  flex-direction: column;\n}\n\n.road-summary-card strong {\n  font-size: 1.4rem;\n  color: #2d4a3a;\n}\n\n.road-summary-card span {\n  color: #5d7466;\n  font-size: 0.85rem;\n}\n\n.attach-damage-btn {\n  background: #4a7c59;\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 18px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.attach-damage-btn:hover {\n  background: #3d684b;\n}\n\n.road-empty {\n  color: #5d7466;\n  margin: 8px 0 0;\n}\n\n.road-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.road-card {\n  display: grid;\n  grid-template-columns: 160px 1fr 230px;\n  gap: 14px;\n  background: #fff;\n  border: 1px solid #e3eee6;\n  border-radius: 14px;\n  overflow: hidden;\n}\n\n.road-card-photo,\n.road-card > img {\n  width: 160px;\n  height: 100%;\n  min-height: 160px;\n  object-fit: cover;\n  background: #eef5f0;\n}\n\n.road-card-body {\n  padding: 12px 14px 12px 0;\n  color: #2d4a3a;\n}\n\n.road-card-body p {\n  margin: 2px 0;\n  font-size: 0.92rem;\n}\n\n.road-card-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.road-card-top h4 {\n  margin: 0;\n}\n\n.road-card-title {\n  font-weight: 700;\n}\n\n.road-card-date {\n  color: #6b7f72;\n  font-size: 0.82rem !important;\n}\n\n.sev {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 36px;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 0.85rem;\n  color: #1d3326;\n}\n\n.sev-N1 { background: #b7e4c7; }\n.sev-N2 { background: #ffe08a; }\n.sev-N3 { background: #f4a261; }\n.sev-N4 { background: #e76f6f; color: #fff; }\n\n.road-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(20, 32, 24, 0.45);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 72px 16px 40px;\n  z-index: 1200;\n  overflow: auto;\n}\n\n.road-modal {\n  background: #fff;\n  width: min(640px, 100%);\n  border-radius: 16px;\n  padding: 18px 18px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.road-modal-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.road-modal-head h3 {\n  margin: 0;\n  color: #2d4a3a;\n}\n\n.road-close {\n  border: none;\n  background: transparent;\n  font-size: 1.6rem;\n  cursor: pointer;\n  line-height: 1;\n}\n\n.road-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  color: #2d4a3a;\n  font-weight: 600;\n  font-size: 0.92rem;\n}\n\n.road-field input,\n.road-field select,\n.road-field textarea {\n  font-weight: 400;\n  font-size: 16px;\n  border: 1px solid #c9ddd0;\n  border-radius: 8px;\n  padding: 8px 10px;\n  color: #2d4a3a;\n  background: #fff;\n  font-family: inherit;\n}\n\n.road-field textarea {\n  resize: vertical;\n}\n\n.road-preview {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #5d7466;\n  font-size: 0.85rem;\n}\n\n.road-preview img {\n  width: 120px;\n  height: 90px;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.road-camera {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: stretch;\n}\n\n.road-camera video,\n.road-camera > img {\n  width: 100%;\n  max-height: min(58vh, 480px);\n  object-fit: contain;\n  border-radius: 12px;\n  background: #12241b;\n}\n\n.road-camera .attach-damage-btn,\n.road-camera .road-cancel {\n  align-self: center;\n}\n\n.road-camera-actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n}\n\n.road-detection {\n  position: relative;\n  display: block;\n}\n\n.road-detection img {\n  width: 100%;\n  height: auto;\n  max-height: 420px;\n  object-fit: contain;\n  background: #12241b;\n}\n\n.road-box {\n  position: absolute;\n  border: 3px solid #e23b3b;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.4);\n}\n\n.road-box span {\n  position: absolute;\n  left: -3px;\n  top: -1.6rem;\n  background: #e23b3b;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 2px 6px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.road-result {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #2d4a3a;\n  font-weight: 600;\n}\n\n.road-note {\n  margin: 0;\n  color: #5d7466;\n  font-size: 0.88rem;\n}\n\n.road-error {\n  margin: 0;\n  color: #9b2c2c;\n  font-weight: 600;\n}\n\n.road-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.road-cancel {\n  background: #eef3f0;\n  border: none;\n  border-radius: 10px;\n  padding: 12px 16px;\n  cursor: pointer;\n  color: #2d4a3a;\n}\n\n.road-card-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 9px;\n}\n\n.road-small-btn,\n.road-delete-btn {\n  border-radius: 8px;\n  padding: 7px 10px;\n  font-size: 0.82rem;\n  cursor: pointer;\n}\n\n.road-small-btn {\n  border: 1px solid #4a7c59;\n  color: #365d42;\n  background: #f4faf6;\n}\n\n.road-small-btn:hover {\n  background: #e8f4eb;\n}\n\n.road-delete-btn {\n  border: 1px solid #d38b8b;\n  color: #8d2f2f;\n  background: #fff6f6;\n}\n\n.road-delete-btn:hover {\n  background: #fdeaea;\n}\n\n.road-card-status {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  padding: 14px;\n  border-left: 1px solid #e3eee6;\n}\n\n.road-card-status.is-ok {\n  background: #f3faf5;\n}\n\n.road-card-status.is-open {\n  background: #fff7f6;\n}\n\n.road-status-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-weight: 700;\n}\n\n.road-card-status.is-ok .road-status-label {\n  color: #217a45;\n}\n\n.road-card-status.is-open .road-status-label {\n  color: #b42318;\n}\n\n.road-card-status.is-pending {\n  background: #fff8e8;\n}\n\n.road-card-status.is-pending .road-status-label {\n  color: #8a5a00;\n}\n\n.road-review-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #c48a12;\n  background: #fff4d6;\n  color: #7a4e00;\n  border-radius: 10px;\n  padding: 10px 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.road-review-btn:hover {\n  background: #ffe8ad;\n}\n\n.road-delete-pending {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 8px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  background: #fff8e8;\n  color: #8a5a00;\n  font-weight: 700;\n}\n\n.road-delete-pending span {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.road-pin {\n  background: transparent;\n  border: none;\n}\n\n.road-pin span {\n  display: block;\n  width: 16px;\n  height: 16px;\n  margin-left: 3px;\n  border-radius: 50% 50% 50% 0;\n  transform: rotate(-45deg);\n  border: 2px solid #fff;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);\n}\n\n.road-remedy-btn {\n  border: 1px solid #217a45;\n  background: #217a45;\n  color: #fff;\n}\n\n.road-remedy-btn:hover {\n  background: #1b6539;\n}\n\n.road-remedy-thumb {\n  width: 96px;\n  height: 72px;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.road-export-modal {\n  width: min(420px, 100%);\n}\n\n.road-export-options,\n.road-remedy-choices {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.road-file-label {\n  width: fit-content;\n}\n\n.road-remedy-preview {\n  width: 100%;\n  max-height: 320px;\n  object-fit: contain;\n  border-radius: 12px;\n  background: #eef5f0;\n}\n\n.road-map-backdrop {\n  z-index: 1200;\n}\n\n.road-map-modal {\n  width: min(960px, 100%);\n  background: #fff;\n  border-radius: 16px;\n  padding: 18px;\n}\n\n.road-map {\n  width: 100%;\n  height: min(70vh, 620px);\n  min-height: 380px;\n  margin-top: 14px;\n  border-radius: 12px;\n  z-index: 1;\n}\n\n.road-map-popup {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 190px;\n}\n\n.road-map-popup img {\n  width: 100%;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 6px;\n  margin-bottom: 4px;\n}\n\n.road-work-order {\n  margin-top: 8px !important;\n  padding: 8px 10px;\n  background: #f4faf6;\n  border-left: 3px solid #4a7c59;\n  border-radius: 6px;\n  line-height: 1.35;\n}\n\n.road-video-icon {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border: 1px solid #4a7c59;\n  border-radius: 999px;\n  background: #f4faf6;\n  color: #2d4a3a;\n  cursor: pointer;\n}\n\n.road-video-icon:hover {\n  background: #e5f3ea;\n}\n\n.road-video-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.road-video-field video,\n.road-video-preview,\n.road-video-player {\n  width: 100%;\n  min-height: 220px;\n  max-height: 420px;\n  background: #111;\n  border-radius: 12px;\n}\n\n.attach-damage-btn:disabled,\n.road-cancel:disabled,\n.road-close:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 860px) {\n  .road-card {\n    grid-template-columns: 140px 1fr;\n  }\n  .road-card-status {\n    grid-column: 1 / -1;\n    border-left: none;\n    border-top: 1px solid #e3eee6;\n  }\n}\n\n@media (max-width: 640px) {\n  .road-card {\n    grid-template-columns: 1fr;\n  }\n  .road-card-photo,\n  .road-card > img {\n    width: 100%;\n    height: 180px;\n  }\n  .road-card-body {\n    padding: 0 12px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
